import LottiePlayer from '~/src/components/LottiePlayer'
import { cn } from '~/src/lib/utils'

interface Props {
  width?: number | string
  height?: number | string
  loop?: boolean
  autoplay?: boolean
  forceTheme?: 'light' | 'dark'
}

const AnimatedLoaderDupeLogo: React.FC<Props> = ({
  width = 500,
  height = 210,
  loop = true,
  autoplay = true,
  forceTheme,
}) => {
  return (
    <LottiePlayer
      src='https://lottie.host/c8617743-2ac4-4a78-877d-6bb76ca3c8de/9Rx2u66Glr.lottie'
      className={cn('relative -top-4 md:-top-2', {
        invert: forceTheme === 'dark',
        'dark:invert': forceTheme !== 'dark',
      })}
      loop={loop}
      autoplay={autoplay}
      style={{
        height,
        width,
      }}
    />
  )
}

export default AnimatedLoaderDupeLogo
